// import "./ComponentsStyles/StickyContactButtons.css";
// import { FaPhone, FaShoppingCart } from "react-icons/fa6";
// import { RiShoppingCartFill } from "react-icons/ri";
// import { useNavigate } from "react-router-dom";
// import { FaPrescription } from "react-icons/fa";
// import React, { useState } from "react";

// import { useCart } from "../Contexts/Cart.contexts";
// import CallBackModal from "../PageElements/HomePageElements/CallBackModal";
// import PrescriptionUpload from "../PageElements/HomePageElements/PrescriptionUpload";

// const StickyContactButtons = () => {
//   const { cartItems } = useCart();
//   const navigator = useNavigate();
//   const [modalOpen, setModalOpen] = useState(false);
//   const [showModal, setShowModal] = useState(false);

//   return (
//     <div className="sticky-buttons">
//       <div className="hero-float-icons">
//         <button
//           className="icon-circle cart-btn"
//           onClick={() => navigator("/cart")}
//           title="Go to Cart"
//         >
//           <RiShoppingCartFill size={25} color="black" />
//           {cartItems.length > 0 && (
//             <span className="cart-badge">{cartItems.length}</span>
//           )}
//         </button>
//         <button
//           className="icon-circle"
//           title="Call Us"
//           onClick={() => setModalOpen(true)}
//         >
//           <FaPhone size={25} color="black" />
//         </button>

//         <button className="icon-circle" title="Upload prescription" onClick={() => setShowModal(true)}>
//           <FaPrescription size={25} color="black" />
//         </button>
//       </div>
//       {modalOpen && <CallBackModal onClose={() => setModalOpen(false)} />}
//       {showModal && <PrescriptionUpload onClose={() => setShowModal(false)} />}
//     </div>
//   );
// };

// export default StickyContactButtons;
import "./ComponentsStyles/StickyContactButtons.css";
import { FaPhone, FaPrescription } from "react-icons/fa";
import { RiShoppingCartFill } from "react-icons/ri";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useState } from "react";
import { useCart } from "../Contexts/Cart.contexts";
import CallBackModal from "../PageElements/HomePageElements/CallBackModal";
import PrescriptionUpload from "../PageElements/HomePageElements/PrescriptionUpload";
import { RiCustomerService2Fill } from "react-icons/ri";
import { RiStethoscopeFill } from "react-icons/ri";
const StickyContactButtons = () => {
  const { cartItems } = useCart();
  const navigator = useNavigate();
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const isHomePage = location.pathname === "/";

  // Show Cart if items > 0 OR if on homepage
  // const showCartButton = isHomePage || cartItems.length > 0;
  const showCartButton = cartItems.length > 0;

  return (
    <div className="sticky-buttons">
      <div className="hero-float-icons">

        {/* CART BUTTON */}
        {showCartButton && (
          <button
            className="icon-circle cart-btn"
            onClick={() => navigator("/cart")}
            title="Go to Cart"
          >
            <RiShoppingCartFill size={25} color="black" />
            {cartItems.length > 0 && (
              <span className="cart-badge">{cartItems.length}</span>
            )}
          </button>
        )}

        {/* OTHER BUTTONS ONLY ON HOME PAGE */}
        {isHomePage && (
          <>
          <button
              className="icon-circle"
              title="Callback"
              onClick={() => setModalOpen(true)}
            >
              <RiCustomerService2Fill size={20} color="black" />
            </button>
            

            <button
              className="icon-circle"
              title="Upload Rx"
              onClick={() => setShowModal(true)}
            >
              <FaPrescription size={20} color="black" />
            </button>
            <button
              className="icon-circle"
              title="Doctor Directory"
              onClick={() => navigator('/doctorDirectory')}
            >
              <RiStethoscopeFill size={20} color="black" />
            </button>

           
          </>
        )}

      </div>

      {modalOpen && <CallBackModal onClose={() => setModalOpen(false)} />}
      {showModal && (
        <PrescriptionUpload onClose={() => setShowModal(false)} />
      )}
    </div>
  );
};

export default StickyContactButtons;
